import { useRecoilValue } from 'recoil'
import { IOption } from '@/types/global.ts'
import { CSSProperties, useMemo } from 'react'
import { IParameter } from '@/pages/Parameters/parameters.types.ts'
import parametersAtom from '@/pages/Parameters/parameters.atom.ts'
import SearchDropdownInput from '@/shared/Inputs/SearchDropdownInput'

interface IProps {
  value: IParameter['id']
  name: string
  onChange: (val: IParameter['id'], name: string) => void
  placeholder?: string
  wrapperStyle?: CSSProperties
}

const ParameterDropdown = (props: IProps) => {
  const parameters = useRecoilValue(parametersAtom).items

  const options: IOption<IParameter['id']>[] = useMemo(() => {
    return parameters.map((p) => ({ title: p.name, value: p.id }))
  }, [parameters])

  return (
    <SearchDropdownInput
      options={options as any}
      selectedOption={props.value as any}
      title={props.placeholder || 'Выберите из списка'}
      onSelect={props.onChange}
      name={props.name}
      wrapperStyle={props.wrapperStyle}
    />
  )
}

export default ParameterDropdown
